import { Armchair, Box, ImagePlus, Monitor, PanelTop, Plus, Presentation, Sprout, Table2, Trash2, Upload } from 'lucide-react'
import { ELEMENT_TYPES, TOPOLOGIES } from '../data'
import { TopologyIcon } from './Icons'

const icons = {
  wall: PanelTop,
  counter: Presentation,
  table: Table2,
  chair: Armchair,
  screen: Monitor,
  plant: Sprout,
  hanging: Box,
}

function NumberField({ label, value, onChange, suffix = 'm', min = 0.5, max = 20, step = 0.25 }) {
  return (
    <label className="dimension-row">
      <span>{label}</span>
      <span className="input-with-suffix">
        <input type="number" value={value} min={min} max={max} step={step} onChange={(event) => onChange(Number(event.target.value))} />
        <span>{suffix}</span>
      </span>
    </label>
  )
}

const surfaceLabels = { back: 'Ściana tylna', left: 'Ściana lewa', right: 'Ściana prawa' }

function availableWallSurfaces(topology) {
  if (topology === 'island') return []
  const surfaces = ['back']
  if (topology === 'l-left' || topology === 'u') surfaces.push('left')
  if (topology === 'l-right' || topology === 'u') surfaces.push('right')
  return surfaces
}

function WallGraphic({ surface, graphic, onUpload, onRemove }) {
  return (
    <div className="surface-graphic-row">
      <span className="surface-graphic-preview">
        {graphic?.dataUrl ? <img src={graphic.dataUrl} alt="" /> : <ImagePlus size={16} />}
      </span>
      <span className="surface-graphic-name"><strong>{surfaceLabels[surface]}</strong><small>{graphic?.name || 'Brak grafiki'}</small></span>
      <label className="surface-graphic-upload" title={`Dodaj grafikę: ${surfaceLabels[surface]}`}>
        <Upload size={14} /><input type="file" accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" onChange={(event) => onUpload(surface, event)} />
      </label>
      {graphic ? <button type="button" className="surface-graphic-remove" title="Usuń grafikę" onClick={() => onRemove(surface)}><Trash2 size={14} /></button> : null}
    </div>
  )
}

export default function LeftSidebar({ project, setTopology, setDimension, addElement, addCustomElement, onOpenCreator, onImportElement, onUploadWallGraphic, onRemoveWallGraphic }) {
  const wallSurfaces = availableWallSurfaces(project.topology)
  return (
    <aside className="left-sidebar panel">
      <div className="panel-heading"><h2>Konfiguracja</h2></div>

      <section className="sidebar-section">
        <h3>Topologia stoiska</h3>
        <div className="topology-grid">
          {TOPOLOGIES.map((topology) => (
            <button
              className={`topology-button ${project.topology === topology.id ? 'selected' : ''}`}
              type="button"
              key={topology.id}
              onClick={() => setTopology(topology.id)}
              aria-pressed={project.topology === topology.id}
            >
              <TopologyIcon type={topology.id} />
              <span>{topology.label}</span>
            </button>
          ))}
        </div>
      </section>

      <section className="sidebar-section">
        <h3>Wymiary stoiska</h3>
        <div className="dimension-list">
          <NumberField label="Szerokość" value={project.dimensions.width} onChange={(value) => setDimension('width', value)} min={2} max={15} />
          <NumberField label="Głębokość" value={project.dimensions.depth} onChange={(value) => setDimension('depth', value)} min={2} max={12} />
          <NumberField label="Wysokość" value={project.dimensions.height} onChange={(value) => setDimension('height', value)} min={2.2} max={5} />
        </div>
      </section>

      <section className="sidebar-section wall-graphics-section">
        <h3>Grafiki ścian</h3>
        {wallSurfaces.length ? (
          <div className="surface-graphic-list">
            {wallSurfaces.map((surface) => <WallGraphic key={surface} surface={surface} graphic={project.surfaceGraphics?.[surface]} onUpload={onUploadWallGraphic} onRemove={onRemoveWallGraphic} />)}
          </div>
        ) : <p className="custom-empty">Układ wyspowy nie ma ścian konstrukcyjnych.</p>}
        <p className="surface-graphic-help">PDF (pierwsza strona), JPG lub PNG.</p>
      </section>

      <section className="sidebar-section library-section">
        <h3>Biblioteka elementów</h3>
        <div className="element-library">
          {Object.entries(ELEMENT_TYPES).map(([type, def]) => {
            const Icon = icons[type]
            return (
              <button type="button" key={type} onClick={() => addElement(type)}>
                <Icon size={20} strokeWidth={1.7} />
                <span>{def.label}</span>
                <small>+ {new Intl.NumberFormat('pl-PL').format(def.price)} zł</small>
              </button>
            )
          })}
        </div>
        <div className="custom-library-header"><h3>Własne elementy</h3><span>{project.customElements.length}</span></div>
        <div className="element-library custom-library">
          {project.customElements.map((definition) => (
            <button type="button" key={definition.id} onClick={() => addCustomElement(definition)}>
              <Box size={20} strokeWidth={1.7} />
              <span>{definition.name}</span>
              <small>+ dodaj</small>
            </button>
          ))}
          {project.customElements.length === 0 ? <p className="custom-empty">Utworzone lub importowane elementy pojawią się tutaj.</p> : null}
        </div>
        <div className="custom-library-actions">
          <button type="button" onClick={onOpenCreator}><Plus size={15} />Utwórz element</button>
          <label><Upload size={15} />Importuj element<input type="file" accept=".json,.iqexpo-element.json" onChange={onImportElement} /></label>
        </div>
      </section>
    </aside>
  )
}
